import * as React from 'react';

import ReactMarkdown from 'react-markdown';

import { Message } from '../types';

interface MessagesListProps {
  messages: Message[];
  messagesEndRef: React.RefObject<HTMLDivElement>;
}

export const MessagesList: React.FC<MessagesListProps> = ({ messages, messagesEndRef }) => {
  return (
    <div className='flex-1 space-y-4 overflow-y-auto p-6'>
      {messages.map((message) => (
        <div key={message.id} className={message.role === 'user' ? 'text-right' : 'text-left'}>
          <div
            className={`inline-block max-w-xs rounded-lg px-4 py-2 lg:max-w-md ${
              message.role === 'user' ? 'bg-blue-500 text-white' : 'border border-gray-200 bg-white text-gray-900'
            }`}
          >
            {/* Render message content and parts */}
            {message.parts ? (
              message.parts.map((part, index) => (
                <div key={index}>
                  {part.type === 'text' && (
                    <div className='text-sm'>
                      <ReactMarkdown>{part.text}</ReactMarkdown>
                    </div>
                  )}

                  {part.type === 'tool-invocation' && (
                    <div className='mt-2'>
                      <pre className='overflow-x-auto rounded border bg-gray-100 p-2 font-mono text-xs text-gray-700'>
                        {`${part.toolInvocation.toolName} ${Object.entries(part.toolInvocation.args)
                          .map(([key, value]) => `${key}: ${value}`)
                          .join(', ')}`}
                      </pre>

                      {/* Display tool result if available and call is complete */}
                      {part.toolInvocation.state === 'result' && (
                        <div className='mt-1'>
                          <div className='mb-1 text-xs text-gray-500'>Result:</div>
                          <pre className='overflow-x-auto rounded border bg-green-50 p-2 font-mono text-xs text-green-800'>
                            {typeof part.toolInvocation.result === 'string'
                              ? part.toolInvocation.result
                              : JSON.stringify(part.toolInvocation.result, null, 2)}
                          </pre>
                        </div>
                      )}

                      {/* Show loading state for partial calls */}
                      {part.toolInvocation.state === 'partial-call' && (
                        <div className='mt-1'>
                          <div className='text-xs italic text-gray-500'>Tool executing...</div>
                        </div>
                      )}
                    </div>
                  )}

                  {part.type === 'reasoning' && (
                    <div className='mt-2'>
                      <div className='mb-1 text-xs text-gray-500'>Reasoning:</div>
                      <div className='rounded border bg-blue-50 p-2 text-xs text-blue-800'>{part.reasoning}</div>
                    </div>
                  )}
                </div>
              ))
            ) : (
              // Fallback for messages without parts (backward compatibility)
              <div className='text-sm'>
                <ReactMarkdown>{message.content}</ReactMarkdown>
              </div>
            )}
          </div>
        </div>
      ))}
      <div ref={messagesEndRef} />
    </div>
  );
};
